module.exports = __webpack_public_path__ + "img/sales-historic.cfaeddc2.png";